import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import TrustSection from './components/TrustSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Finds Baby',
    ...(siteUrl ? { url: siteUrl } : {}),
    description:
      'Discover the best Kakobuy Spreadsheet with thousands of organized finds, product guides, comparisons, and shopping resources. Updated daily.',
    inLanguage: 'en',
    publisher: {
      '@type': 'Organization',
      name: 'Kakobuy Finds Baby',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <HeroSection />
      <CategoryGrid />
      <TrustSection />
      <ArticleSection />
      <CTASection />
      <Footer />
    </div>
  );
}